// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__nSBoe","right":"styles_right__2wiwu"};